export default {
  downloadBanner: {
    title: "RC CITY veb-ilovasini smartfoningizga o‘rnating",
    description:
      "O‘rnatish usulini tanlang va servisdan telefonda oddiy mobil ilova kabi foydalaning",
    iosButton: "iOS uchun",
    androidButton: "Android uchun",
    imageAlt: "Ilova o‘rnatilgan telefon",
  },
  applicationAdvantages: {
    title:
      "RC CITY veb-ilovasi — bu veb-sayt va mobil ilovaning asosiy afzalliklarining eng yaxshi uyg‘unligi",
    advantages: {
      0: {
        title: "Ekranga o‘rnatish",
        description:
          "Saytning barcha funksiyalariga tez va qulay kirish uy ekraningizdan bevosita amalga oshadi.",
      },
      1: {
        title: "Hajmi 1 MB dan kichik",
        description:
          "Qurilmangiz xotirasini tejaydi va kam resurs talab qiladi.",
      },
      2: {
        title: "To‘liq ekran rejimi",
        description:
          "Manzil panelisiz ochiladi va barcha qurilmalarga moslashadi.",
      },
      3: {
        title: "Ishga tushganda yangilanadi",
        description:
          "Google Play yoki App Store’dan qo‘lda yangilash talab etilmaydi.",
      },
      4: {
        title: "Tez yuklanadi",
        description:
          "Yuklash boshlanishidan birinchi element chiqishigacha odatda 1 soniyadan kam vaqt ketadi.",
      },
      5: {
        title: "Oflayn ishlash imkoniyati",
        description:
          "Ba’zi ma’lumotlarni keshda saqlab, internet bo‘lmaganida ham ko‘rsatadi.",
      },
      6: {
        title: "Fon rejimi",
        description:
          "Ma’lumotlarni sinxronlash yoki push-bildirishnomalar olish uchun ilovani ochiq saqlash shart emas.",
      },
      7: {
        title: "Silliq animatsiya",
        description:
          "Tez ishlaydi, tabiiy mobil ilova singari silliq animatsiyaga ega.",
      },
      8: {
        title: "Energiyani tejaydi",
        description:
          "Kam quvvat sarflaydi, bu batareya ishlash vaqtini uzaytiradi.",
      },
    },
  },

  instructionIOS: {
    title: "RC CITY veb-ilovasini iOS’da qanday o‘rnatish kerak",
    steps: {
      first: {
        text: "Telefoningizda Safari brauzerida <a href='https://rc.city/' target='_blank'>rc.city</a> saytini oching va «Ulashish» belgisi ustiga bosing.",
      },
      second: {
        text: "Ochilgan oynada pastga aylantiring va «Bosh ekranga qo‘shish» bo‘limini tanlang.",
      },
      third: {
        text: "O‘ng yuqori burchakdagi «Qo‘shish» tugmasini bosing — RC CITY belgisi bosh ekranda paydo bo‘ladi.",
      },
    },
  },

  instructionAndroid: {
    title: "RC CITY veb-ilovasini Android’da qanday o‘rnatish kerak",
    description: {
      part1: "Telefoningizdan bosing",
      installButton: "«Android’ga o‘rnatish»",
      part2: "yoki quyidagi bosqichlarni brauzer orqali qo‘lda bajaring.",
    },
    steps: {
      first: {
        text: "Telefoningizda <a href='https://rc.city/' target='_blank'>rc.city</a> saytini oching va yuqori o‘ng burchakdagi «Ko‘proq» belgisi ustiga bosing.",
      },
      second: {
        text: "Ochilgan menyuda pastga aylantiring va «Bosh ekranga qo‘shish» variantini tanlang.",
      },
      third: {
        text: "Chiqqan oynada «O‘rnatish» tugmasini bosing — RC CITY belgisi bosh ekranda paydo bo‘ladi.",
      },
    },
  },

  pwaHelp: {
    title: "O‘rnatishda qiyinchilik yuz berdimi?",
    description:
      'Texnik yordam xizmatiga <a href="https://t.me/rccity" target="_blank">Telegram</a> orqali yoki <a href="mailto:hello@rc.city" target="_blank">hello@rc.city</a> elektron pochtasi orqali murojaat qiling',
  },
};
